export default function trackEvent(click_section, click_link) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'meganav',
    click_section: `${click_section}`,
    click_link: `${click_link}`
  });
  return;
}
